import React from 'react';

interface GaugeStatusDef {
  name: string;
  color: string;
}

// Refer to for color spec: https://magnetic.cisco.com/0a43ab5cd/v/0/p/532681-color/b/758b26
const GAUGE_STATUS_DEFS: GaugeStatusDef[] = [
  { name: 'Normal', color: 'var(--color-positive-bg)' },
  { name: 'Warning', color: 'var(--color-warning-bg)' },
  { name: 'Critical', color: 'var(--color-severe-warning-bg)' },
  { name: 'Unknown', color: 'var(--color-dormant-bg)' },
];

export const toGaugeStatus = (thresholds: number[], value: number) => {
  let status;
  if (thresholds && thresholds.length >= 3 && value) {
    status = 'Normal';
    if (value > thresholds[2]) {
      status = 'Critical';
    } else if (value > thresholds[1]) {
      status = 'Warning';
    }
  } else {
    status = 'Unknown';
  }
  return status;
};

export const statusToHealthColor = (status: string) => {
  const def = GAUGE_STATUS_DEFS.filter(hdef => hdef.name === status);
  return def[0].color;
};

export const toGaugeTooltip = (
  thresholds: number[],
  metricTitle: string,
  value: number,
  maxValue: number,
  unit: string,
  baselineValue: number,
  targetValue: number,
  showThresholds: boolean,
) => {
  let tooltipText = '';
  let threshholdLegend = '';
  if (value) {
    tooltipText =
      '<tr><td><span style="margin-right: 4px">' +
      metricTitle +
      '</span></td><td style="text-align: right"><b>' +
      value +
      ' ' +
      unit +
      '</b><td><tr>';
  }
  if (thresholds && thresholds.length === 3) {
    threshholdLegend =
      '<table>' +
      '<tr><td><span style="margin-right: 10px"><span style="height: 7px; width: 7px; background-color: var(--color-severe-warning-bg); border-radius: 50%; display: inline-block"></span> Critical</span></td><td> > <b>' +
      thresholds[2] +
      ' ' +
      unit +
      '</b></td></tr>' +
      '<tr><td><span style="height: 7px; width: 7px; background-color: var(--color-warning-bg); border-radius: 50%; display: inline-block"></span> Warning</td><td> > <b>' +
      thresholds[1] +
      ' ' +
      unit +
      '</b></td></tr>' +
      '<tr><td><span style="height: 7px; width: 7px; background-color: var(--color-positive-bg); border-radius: 50%; display: inline-block"></span> Normal</td><td> < <b>' +
      thresholds[1] +
      ' ' +
      unit +
      '</b></td></tr>' +
      '</table>';
  }
  if (baselineValue) {
    tooltipText +=
      '<tr><td>Baseline</td><td style="text-align: right"><b>' + baselineValue + ' ' + unit + '</b><td><tr>';
  }
  if (targetValue) {
    tooltipText += '<tr><td>Target</td><td style="text-align: right"><b>' + targetValue + ' ' + unit + '</b><td><tr>';
  }

  if (threshholdLegend) {
    return (
      '<div style="display: flex;flex-direction: column;align-items: center;"><table style="font-size: 12px">' +
      tooltipText +
      '</table><div style="width: 80%;border: 1px solid var(--color-default-border-medium); margin: 4px 0 4px 0;"></div><table style="font-size: 10px">' +
      threshholdLegend +
      '</table></div>'
    );
  } else {
    return (
      '<div style="display: flex;flex-direction: column;align-items: center;"><table style="font-size: 12px">' +
      tooltipText +
      '</table>'
    );
  }
};

export const toGaugeTitle = (unit: string, metricTitle: string, value: number) => {
  if (value) {
    return (
      '<div style="text-align:center; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100px">' +
      '<span style="font-size: 15px; font-weight: bold">' +
      value +
      '</span>' +
      ' <span style="font-size: 15px; font-weight: normal">' +
      metricTitle +
      ' ' +
      unit +
      '</span>' +
      '</div>'
    );
  } else {
    return (
      '<div style="text-align:center; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100px">' +
      '<span style="font-size: 15px; font-weight: bold">' +
      '-' +
      '</span>' +
      '<span style="font-size: 15px; font-weight: normal">' +
      metricTitle +
      ' ' +
      unit +
      '</span>' +
      '</div>'
    );
  }
};
